<template>
  <div>
    <b-modal
      v-model="modalStatus"
      centered
      size="lg"
      button-size="sm"
      no-close-on-backdrop
      scrollable
    >
      <template #modal-header>
        <h5 class="modal-title">Roles Column Chooser</h5>
        <button type="button" class="close" @click="closeModal()">×</button>
      </template>
      <b-alert v-model="hasUnknownError" variant="danger" fade>
        {{ unknownErrorMessage }}
      </b-alert>

      <b-alert v-model="hasError" variant="danger" fade>
        {{ errorMessage }}
      </b-alert>

      <div class="mb-4">
        <small>Selected roles are then displayed as individual columns. This allows roles to be added or removed quickly.</small>
      </div>

      <b-form-checkbox-group
        v-model="selected"
        :options="roles"
        class="mb-3 custom-checkboxes"
        value-field="field_001"
        text-field="rolle"
        disabled-field="notEnabled"
      ></b-form-checkbox-group>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="secondary"
            size="sm"
            class="float-right"
            hidden
          >
          </b-button>
          <b-row>
            <b-col lg="12">
              <b-button v-if="selected.length > 0" @click="removeSelected" size="sm" variant="secondary">Remove all</b-button>
              <b-button variant="primary" size="sm" disabled v-if="isSubmitting">
                <b-spinner small></b-spinner>
                Save
              </b-button>
              <b-button @click="saveSelectedRoles" class="float-right" size="sm" variant="primary" ref="submitSelectedRoles" v-else>Save</b-button>
            </b-col>
          </b-row>
        </div>
      </template>
    </b-modal>
  </div>
</template>

  <script>
  import { mapGetters } from 'vuex'
  import { validateField } from '@/helpers/formHelper.js'
  export default {
    name: 'save-template',
    components: {
    },
    props: {
      template: Object
    },
    data () {
      return {
        isSubmitting: false,
        hasUnknownError: false,
        unknownErrorMessage: '',
        hasError: false,
        errorMessage: '',
        modalAlert: false,
        modalStatus: false,
        selected: []
      }
    },
    created () {
      this.getRoles()
    },
    methods: {
      saveSelectedRoles () {
        this.$emit('save-selected-roles', this.selected)
        this.modalStatus = false
      },
      async getRoles () {
        try {
          const { errors } = await this.$store.dispatch('basicValues/GET_ROLES')
          if (errors) throw errors
        } catch (err) {
          this.hasError = true
          this.errorMessage = this.$t('formError.unknownwError')
          setTimeout(() => {
            this.hasError = false
          }, 5000)
          console.error(err)
        }
      },
      removeSelected () {
        this.selected = []
      },
      openModal () {
        this.modalStatus = true
      },
      closeModal () {
        this.modalStatus = false
      },
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      }
    },
    computed: {
      ...mapGetters({
        roles: 'basicValues/ROLES'
      })
    }
  }
  </script>

  <style lang="scss">
  .custom-checkboxes .custom-control {
    width: 30%;
    margin-right: .5rem;

    @include media-breakpoint-down(md) {
        width: 50%;
        margin-right: 0;
    }

    @include media-breakpoint-down(sm) {
        width: 100%;
    }
  }
  </style>
